package com.downdogapp.client.views.start

import com.downdogapp.*
import com.downdogapp.Position.RELATIVE
import com.downdogapp.client.*
import com.downdogapp.client.controllers.start.MenuPage
import com.downdogapp.client.resources.Images
import com.downdogapp.client.singleton.App
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.CustomRow.Companion.headerRow
import com.downdogapp.client.widget.StructuredRow.Companion.leftIconRow
import com.downdogapp.client.widget.StructuredRow.Companion.structuredRow
import org.w3c.dom.HTMLSpanElement

actual class MenuPageView : AbstractView(), View {

  private var titleLabel: HTMLSpanElement
  private var table: TableView

  override val root = createDiv {
    position = RELATIVE
    titleLabel = startPageTitle()

    startPageContent {
      table = tableView(::getContents)
    }
  }

  actual fun refreshView() {
    titleLabel.text = MenuPage.title
    table.refreshContents()
  }

  private fun getContents(): TableContents {
    val rows = mutableListOf<TableRowInit>()
    rows += listOfNotNull(
      MANIFEST.membershipButtonText?.let { text ->
        leftIconRow(
          image = Images.MENU_LINK_GENERIC,
          text = text,
          clickFn = MenuPage::membershipClicked
        )
      },
      if (MANIFEST.membershipButtonText == null
          && MANIFEST.email != null)
        leftIconRow(
          image = Images.MENU_LINK_GENERIC,
          text = MANIFEST.email!!,
          subText = MANIFEST.userStartDateText
        )
      else
        null
    )
    if (MANIFEST.subscriptions.isNotEmpty()) {
      rows +=
        listOf(headerRow(Strings.SUBSCRIPTION)) +
        MANIFEST.subscriptions.map { subscription ->
          val clickFn: (() -> Unit)? = if (subscription.description != null)
            { -> MenuPage.subscriptionClicked(subscription) }
          else
            subscription.planButtonUrl?.let { url ->
              { App.openUrl(url) }
            }
          leftIconRow(
            image = Images.SETTINGS_PLAN,
            text = subscription.planButtonText,
            subText = subscription.planButtonSubtext,
            clickFn = clickFn
          )
        }
    }
    rows += listOfNotNull(
      headerRow(Strings.ACCOUNT),
      MANIFEST.email?.let {
        leftIconRow(
          image = Images.EMAIL,
          text = Strings.EMAIL,
          subText = it,
          clickFn = MenuPage::emailClicked
        )
      },
      if (MANIFEST.facebookLinked)
        leftIconRow(
          image = Images.LOCK,
          text = Strings.UNLINK_FROM_FACEBOOK,
          clickFn = MenuPage::facebookClicked
        )
      else
        null,
      if (MANIFEST.googleLinked)
        leftIconRow(
          image = Images.LOCK,
          text = Strings.UNLINK_FROM_GOOGLE,
          clickFn = MenuPage::googleClicked
        )
      else
        null,
      if (MANIFEST.appleLinked)
        leftIconRow(
          image = Images.LOCK,
          text = Strings.UNLINK_FROM_APPLE,
          clickFn = MenuPage::appleClicked
        )
      else
        null,
      if (MANIFEST.hasPassword)
        leftIconRow(
          image = Images.LOCK,
          text = Strings.PASSWORD,
          subText = "*********",
          clickFn = MenuPage::passwordClicked
        )
      else
        null,
      if (MANIFEST.displayChangeLanguage)
        leftIconRow(
          image = Images.LANGUAGE,
          text = Strings.LANGUAGE,
          subText = MANIFEST.languageOptions.find { it.value == Strings.language }!!.label,
          clickFn = MenuPage::languageClicked
        )
      else
        null
    )

    if (MANIFEST.appLinks.isNotEmpty()) {
      rows +=
        listOf(headerRow(Strings.OTHER_APPS)) +
        MANIFEST.appLinks.map { appLink ->
          leftIconRow(
            image = appLink.appType.icon,
            text = appLink.link.label,
            clickFn = { MenuPage.linkClicked(appLink.link) }
          )
        }
    }
    rows +=
      listOfNotNull(
        headerRow(title = Strings.SOCIAL),
        MANIFEST.facebookCommunityUrl?.let { url ->
          leftIconRow(
            image = Images.FACEBOOK,
            text = Strings.FACEBOOK_COMMUNITY,
            clickFn = { App.openFirstValidUrl(listOf(url)) }
          )
        },
        MANIFEST.instagramUrl?.let { url ->
          leftIconRow(
            image = Images.INSTAGRAM,
            text = Strings.INSTAGRAM,
            clickFn = { App.openFirstValidUrl(listOf(url)) }
          )
        },
        headerRow(Strings.MY_DATA),
        if (MANIFEST.displayHistoryPage)
          leftIconRow(
            image = Images.DELETE_HISTORY,
            text = Strings.DELETE_HISTORY,
            clickFn = MenuPage::clearAllHistoryClicked
          )
        else
          null,
        leftIconRow(
          image = Images.SETTINGS_TRASH,
          text = Strings.DELETE_ACCOUNT,
          clickFn = MenuPage::deleteAccountClicked
        ),
        headerRow(Strings.OTHER),
        MANIFEST.email?.let {
          structuredRow(DEFAULT_ROW_HEIGHT_PX, allowSeparator = true) {
            leftImage(Images.PROMOTION)
            leftTextContent(Strings.PROMOTIONAL_EMAILS)
            rightToggle(
              getValue = { MANIFEST.receivingPromotionalEmails },
              onValueChanged = { MenuPage.promotionalEmailsClicked(it) }
            )
          }
        },
        MANIFEST.giftLink?.let { link ->
          leftIconRow(
            image = Images.GIFT,
            text = link.label,
            clickFn = { MenuPage.linkClicked(link) }
          )
        },
        if (MANIFEST.displayEnterCode)
          leftIconRow(
            image = Images.GIFT,
            text = Strings.ENTER_CODE,
            clickFn = MenuPage::enterCodeClicked
          )
        else
          null
      ) +
      MANIFEST.menuLinks.map { link ->
        leftIconRow(
          image = Images.LINK,
          text = link.label,
          clickFn = { MenuPage.linkClicked(link) }
        )
      } +
      listOfNotNull(
        MANIFEST.menuContactMessage?.let {
          leftIconRow(
            image = Images.SUPPORT,
            text = Strings.SUPPORT,
            clickFn = MenuPage::supportClicked
          )
        },
        MANIFEST.supportLink?.let { link ->
          leftIconRow(
            image = Images.SUPPORT,
            text = link.label,
            clickFn = { MenuPage.linkClicked(link) }
          )
        }
      )

    return TableContents(rows = rows, separator = rightSeparator)
  }
}
